// Amde Haymanot — Cathedral Manuscript design system
export const brand = {
  // Core identity
  navy: '#004179',
  gold: '#FFCF00',
  white: '#FFFFFF',
  navyLight: '#1A5A94',
  navyDark: '#001833',
  navyInk: '#000E1F',
  goldLight: '#FFE566',
  goldDark: '#C9A000',
  goldMuted: 'rgba(255, 207, 0, 0.14)',

  // Cool stone surfaces (not warm cream)
  stone: '#E8EEF4',
  stoneDeep: '#D5DEE8',
  surfaceMuted: '#E8EEF4',
  surfaceElevated: '#FFFFFF',
  surfaceInk: '#001833',

  // Text
  ink: '#0B1220',
  inkMuted: '#3D4F63',

  borderSubtle: 'rgba(0, 65, 121, 0.12)',
  borderGold: 'rgba(255, 207, 0, 0.45)',

  shadowSoft: '0 2px 16px rgba(0, 14, 31, 0.06)',
  shadowCard: '0 12px 40px rgba(0, 14, 31, 0.1)',
  shadowHero: '0 24px 80px rgba(0, 14, 31, 0.35)',

  // Architectural radii
  archRadius: '50% 50% 0 0 / 100% 100% 0 0',
  frameRadius: 2,
};

export default brand;
